module.exports = __webpack_public_path__ + "img/remove-ads-plus-plus.ae5a3c0a.png";